import {
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import { FC } from 'react';
import ShowcaseTab from '../../components/ShowcaseTab';
import { ContextoVitrine } from '../../types';

const ABAS: { contexto: ContextoVitrine; titulo: string }[] = [
  { contexto: 'pdp', titulo: 'PDP' },
  { contexto: 'sacola', titulo: 'Sacola' },
];

// mesmo estilo das abas do diagnóstico de mídia
const ESTILO_ABA = {
  fontWeight: 'medium',
  color: 'gray.500',
  borderBottomWidth: '3px',
  _selected: { color: '#469BFF', borderColor: '#469BFF', fontWeight: 'bold' },
};

const Main: FC = () => (
  <Flex
    flexDir="column"
    w="100%"
    minW={0}
    minH={0}
    h="100%"
    p={{ base: 4, lg: 8 }}
    overflowY="auto"
    overflowX="hidden"
    overscrollBehavior="contain"
    backgroundColor="#F9F9F9"
    sx={{ '& > *': { flexShrink: 0 } }}
    css={{
      '&::-webkit-scrollbar': { width: '6px' },
      '&::-webkit-scrollbar-track': { width: '6px' },
      '&::-webkit-scrollbar-thumb': {
        background: '#469BFF',
        borderRadius: '24px',
      },
    }}
  >
    <Heading mb={2} color="#469BFF" fontFamily="Poppins">
      Vitrines de recomendação
    </Heading>
    <Text mb={6} color="gray.600">
      Vitrines &quot;quem comprou também levou&quot; do app, na página do
      produto (PDP) e na sacola
    </Text>

    {/* keepMounted: trocar de aba não perde o que foi editado e não salvo */}
    <Tabs
      minW={0}
      w="100%"
      variant="line"
      colorScheme="blue"
      isLazy
      lazyBehavior="keepMounted"
    >
      <TabList mb={4}>
        {ABAS.map(({ contexto, titulo }) => (
          <Tab key={contexto} {...ESTILO_ABA}>
            {titulo}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {ABAS.map(({ contexto }) => (
          <TabPanel key={contexto} px={0}>
            <ShowcaseTab contexto={contexto} />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  </Flex>
);

export default Main;
